<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom gutter-b card-stretch">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark"
                >Revendas com Plano Mensal</span
              >
              <span class="text-muted mt-3 font-weight-bold font-size-sm"
                >Planos Mensais de revenda</span
              >
            </h3>
          </div>
          <div class="card-body pt-5 pb-0 mt-n3">
            <div class="table-">
              <table class="table table-borderless table-vertical-center">
                <thead>
                  <tr>
                    <th class="p-0">Revenda</th>
                    <th class="p-0">CNPJ</th>
                    <th class="p-0 min-w-50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="valor in valroes" :key="valor">
                    <template
                    >
                      <td class="pl-0">
                        <span class="text-muted font-weight-bold d-block">
                          {{ valor.collection_mensal.NOME }}
                        </span>
                      </td>
                      <td class="pl-0">
                        <span class="text-muted font-weight-500"
                          >{{
                            valor.collection_mensal.CPF_CNPJ
                          }}
                        </span>
                      </td>
                      <td class="text-right pr-0">
                        <button
                          @click="excluir(valor)"
                          class="btn btn-light-danger btn-sm btn-bold"
                        >
                          <Close :size="16" />
                        </button>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";
import Close from "vue-material-design-icons/Close.vue";

export default {
  name: "app-config-renovacoes-valor",
  mixins: [ApplicationMixin],
  components: {
    Close
  },
  data() {
    return {
      valroes: {},
    };
  },
  methods: {
    async getPlanoMensal() {
      try {
        const { data } = await this.$http.get(
          "/renovacoes/config/plano-mensal"
        );
        this.valroes = data;
      } catch {
        return [];
      }
    },
    excluir(data) {
      console.log(data);
      this.$swal
        .fire({
          icon: "info",
          title: "Excluir plano mensal da revenda " + data.collection_mensal['NOME'] + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`
        })
        .then(async result => {
          if (result.isConfirmed) {
            await this.$http.post("/renovacoes/config/plano-mensal/delete", {
              id: data.id,
              idRevenda: data.id_revenda
            });
            this.getPlanoMensal();
            this.$toast.success("Revenda removida com sucesso!");
          }
        });
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.getPlanoMensal();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Plano Mensal",
        action: {
          title: "Nova",
          url: "PlanoMensalCreate"
        }
      }
    ]);
  }
};
</script>
